export const hasChangesToPublish = (publishedAt, updatedAt) => {
  if (publishedAt) {
    return new Date(publishedAt).getTime() < new Date(updatedAt).getTime();
  } else {
    return false;
  }
};

export const getHasChangesToPublish = state => {
  if (state.contentReducer.publishedVersion && state.contentReducer.version) {
    return (
      state.contentReducer.publishedVersion !== state.contentReducer.version
    );
  }
  return hasChangesToPublish(
    state.contentReducer.presentation.publishedAt,
    state.contentReducer.presentation.updatedAt,
  );
};
